module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-803b1e6d16a27b1dfd177950304ae924.png";